export default __webpack_public_path__ + "static/media/icon-apis.3e5275c7.svg";